var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table layout-fixed"},[_c('thead',[_c('tr',[_vm._t("header")],2)]),_c('tbody',[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }